<template>
    <div class="list-page-wrapper">
        <p class="version-txt">{{ $t("common.history") }}</p>
        <div class="version-list">
            <div
                v-for="item in versionList"
                class="version-item"
                :key="item"
                @click="onClick(item)"
            >
                <span class="version-item-txt">{{ item }}</span>
                <!-- <span class="version-item-arrows">></span> -->
                <img :src="arrowRight" class="version-item-img" />
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import * as utils from "@/utils";
import arrowRight from "@/assets/arrow_right.png";
let trace = new utils.Trace("列表", true);

export default {
    data() {
        return {
            versionList: utils.CONST.privacy.dataOption,
            arrowRight
        };
    },
    computed: {
        ...mapState(["lang", "version"])
    },
    methods: {
        onClick(data) {
            const { version } = utils.CONST.privacy.dataMap[data];
            trace("你选择的历史版本:", data, version);

            this.$router.push({
                name: "detailPage",
                query: {
                    lang: this.lang,
                    version,
                    show: false
                }
            });

            // //!  用location跳转新的页面，解决css残留问题
            // location.assign(
            //     location.href.replace(
            //         "list",
            //         `detail?lang=${this.lang}&version=${version}&show=false`
            //     )
            // );

            // this.$router.push({
            //     name: "detailPage",
            //     query: {
            //         lang: this.lang,
            //         version,
            //         show: false,
            //         reload: true //通过版本列表进入不同的历史版本，需要刷新（以便清楚残留css style）
            //     }
            // });
        }
    }
};
</script>
<style scoped>
.list-page-wrapper {
    background-color: #fafafa;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
}
.version-txt {
    padding-top: 0.5rem;
    margin-left: 16pt;
    font-size: 12pt;
    margin-bottom: 0.5rem;
}

.version-list {
    /* border: 1px solid red; */
}

.version-item {
    border-top: 1px solid #f1f1f1;

    height: 52pt;
    /* line-height: 1.75rem; */
    font-size: 0.5rem;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    padding-right: 16pt;
    padding-left: 16pt;
}

.version-item:last-child {
    border-bottom: 1px solid #f1f1f1;
}

.version-item-txt {
    font-size: 16pt;
    /* margin-left: 16pt; */
}

.version-item-arrows {
    font-size: 0.5rem;
    margin-right: 0.75rem;
    color: #a8a7a7;
}

.version-item-img {
    transform: rotate(270deg) scale(0.5);
}
</style>



// WEBPACK FOOTER //
// src/pages/list.vue